import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router'; 
import { Subscription } from 'rxjs/Subscription';
import { ActivatedRoute, Params } from '@angular/router';
import { WebService } from '../services/web/web.service';
import { EncryptService } from '../services/encrypt/encrypt.service';
import { DialogService } from '../services/dialog/dialog.service';
@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent implements OnInit {
private sub: Subscription;
 newpassword;
 confirmpassword;
 
token;
model: any = {};
loading = false;   
returnUrl: string;
messageclass;
message;
flagEnable=true; 
confirmMessage;
  constructor(private dialogService:DialogService,private encryptService:EncryptService,private route: ActivatedRoute,private router: Router,private httpService:WebService,) { }

  ngOnInit() {
  	 this.route.params.subscribe((params: Params) => {
  	 	this.token = params['token']
      });
  }
  updatePassword(){
  	this.model['token'] = this.token;
	let flag = this.checkValidPassword();
    if(!flag){
      this.dialogService.openAlert("The password should be at least 8 characters long and should have at least One Uppercase, One Lowercase, One Number & a special character")
      .then(data=>{
            
      });
      return;
    }


    this.encryptService.encryptPassword(this.model.confirmpassword).then(data=>{
    		let pass = data['encrypted'];
    		this.model["password"] = pass;
    		this.httpService.getResponse('/forgotpasswordroute/readurl',this.model).then(res=>{
        this.message ="Password changed successfully";
			}).catch(err=>{ 
				console.log(err)
			})
			
    }).catch(err=>{

    })
	
  }
  confirmpasswordFun(){
  	
  	if (this.model.newpassword === this.model.confirmpassword){
  		this.flagEnable = false;
  	}else
  	{
  		this.flagEnable = true;
  		this.confirmMessage = "Passwod not matching";
  		
  	}
  }

   checkValidPassword(){
   	
    let hasNumber:boolean = false;
    let hasEightOrMore:boolean = false;
    let hasUpperCase:boolean = false;
    let hasLowerCase:boolean = false;
    hasEightOrMore = this.model.confirmpassword.length >= 8 ? true : false;
    
    if(!hasEightOrMore){
      return false;
    }
    //console.log(this.password);
    var re = new RegExp(".*\\d+");
    var upperCaseRegex = new RegExp("[A-Z]")
    var lowercaseCaseRegex = new RegExp("[a-z]")
    if(re.test(this.model.confirmpassword)){
          hasNumber = true;
    }
    if(upperCaseRegex.test(this.model.confirmpassword)){
        hasUpperCase = true;
    }
    if(lowercaseCaseRegex.test(this.model.confirmpassword)){
        hasLowerCase = true;
    }
    return hasUpperCase && hasLowerCase && hasNumber;

  }

  getYear(){
  return new Date().getUTCFullYear();
}


}
 


// WEBPACK FOOTER //
// ./src/app/forgotpassword/forgotpassword.component.ts